import { useApiPaginated } from "@/hooks/useApiPaginated";
import { queryKeys } from "@/lib/queryKeys";

export interface ApiKey {
  id: string;
  member_id: string;
  member_name: string;
  member_email: string;
  prefix: string;
  last_used_at: string | null;
  is_active: boolean;
  created_at: string;
}

export function useApiKeysPaginated(page: number, pageSize: number, q = "") {
  const { data, total, loading, error, refetch } = useApiPaginated<ApiKey>(
    queryKeys.apiKeys.paginated({ page, pageSize, q }),
    "/api/v2/api-keys",
    page,
    pageSize,
    { q },
    "Failed to load API keys",
  );
  return { keys: data, total, loading, error, refetch };
}
